import React, { createElement, useEffect, useRef, useState } from 'react';
import { Swiper } from 'swiper/esm/react/swiper.js';
import { SwiperSlide } from 'swiper/esm/react/swiper-slide.js';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import 'swiper/swiper.scss';
import moduleCss from './index.module.scss';
import Style from './index.module.scss';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask';
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip';
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip';
import Chip from 'Chip';
import md5 from 'md5';
import { formatImage } from '@ifeng/public_method';
import leftNavImage from './assets/left.png';
import leftNavHoverImage from './assets/leftHover.png';
import rightNavImage from './assets/right.png';
import rightNavHoverImage from './assets/rightHover.png';

SwiperCore.use([Navigation, Autoplay]);

export interface Swiper_cjck_Props {
    style?: object;
    swiperChip: TYPE_Chip;

    // 自动播放
    isAutoPlay: boolean; // 是否开启自动播放
    autoSpeed: number; // 自动播放的速度

    __designMode: string;
}

const Swiper_cjck: React.FC<Swiper_cjck_Props> = (props) => {
    const { swiperChip, style, isAutoPlay, autoSpeed, __designMode } = props;

    const [isReady, setIsReady] = useState(false); // 不设置这个，initialSlide 为 0 时左侧有空白，可能是 swiper6 的bug
    const [isHoverLeft, setIsHoverLeft] = useState(false);
    const [isHoverRight, setIsHoverRight] = useState(false);

    const swiperRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            setIsReady(true);
        }, 100);

        window.addEventListener('resize', () => {
            swiperRef.current.update();
        });

        return () => {
            window.removeEventListener('resize', () => {
                swiperRef.current.update();
            });
        };
    }, []);

    const [swiperIndex, setSwiperIndex] = useState(1);

    const swiperChipData = useChip(swiperChip);
    const swiperChipProps = formatChip(swiperChip);

    const getKey = () => {
        return md5(JSON.stringify({ isAutoPlay, autoSpeed }));
    };

    return (
        <div className={Style.container} style={style}>
            <div className={Style.wrap}>
                <Chip {...swiperChipProps}>
                    <div className={Style.content}>
                        <div className={Style.swiper}>
                            <div className={Style.swiperWrap}>
                                {isReady && (
                                    <Swiper
                                        key={getKey()}
                                        initialSlide={0}
                                        loop={true}
                                        slidesPerView={3}
                                        simulateTouch={__designMode !== 'design'}
                                        navigation={{
                                            prevEl: `.${Style.prev1}, .${Style.prev2}`,
                                            nextEl: `.${Style.next1}, .${Style.next2}`,
                                        }}
                                        onSlideChange={(swiper) => {
                                            setSwiperIndex(
                                                swiper.realIndex < swiperChipData.length - 1
                                                    ? swiper.realIndex + 1
                                                    : 0,
                                            );
                                        }}
                                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                                        autoplay={
                                            isAutoPlay
                                                ? {
                                                      delay: autoSpeed,
                                                      disableOnInteraction: false,
                                                      pauseOnMouseEnter: true,
                                                  }
                                                : false
                                        }
                                        width={952 * 3}
                                    >
                                        {Array.isArray(swiperChipData) && swiperChipData.length
                                            ? swiperChipData.map((item, index) => {
                                                  return (
                                                      <SwiperSlide key={index}>
                                                          <div className={Style.swiperItem}>
                                                              {item.link ? (
                                                                  <a
                                                                      href={item.link}
                                                                      target="_blank"
                                                                  >
                                                                      <img
                                                                          src={formatImage(
                                                                              item.pic,
                                                                              952 * 2,
                                                                              559 * 2,
                                                                              100,
                                                                          )}
                                                                          alt={item.title1}
                                                                      />
                                                                  </a>
                                                              ) : (
                                                                  <img
                                                                      src={formatImage(
                                                                          item.pic,
                                                                          952 * 2,
                                                                          559 * 2,
                                                                          100,
                                                                      )}
                                                                      alt={item.title1}
                                                                  />
                                                              )}
                                                          </div>
                                                      </SwiperSlide>
                                                  );
                                              })
                                            : null}
                                    </Swiper>
                                )}

                                <div className={moduleCss.center}>
                                    <div className={moduleCss.textPart}>
                                        <div className={moduleCss.textPartTitleTop}>
                                            {swiperChipData[swiperIndex]?.title1}
                                        </div>
                                        {swiperChipData[swiperIndex]?.title2 && (
                                            <div className={moduleCss.textPartTitleBottom}>
                                                {swiperChipData[swiperIndex]?.title2}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={`${moduleCss.left} ${moduleCss.prev1}`} />
                            <div className={`${moduleCss.right} ${moduleCss.next1}`} />
                            <div className={`${moduleCss.leftBtn} ${moduleCss.prev2}`}>
                                <img
                                    src={isHoverLeft ? leftNavHoverImage : leftNavImage}
                                    alt=""
                                    onMouseEnter={() => setIsHoverLeft(true)}
                                    onMouseLeave={() => setIsHoverLeft(false)}
                                />
                            </div>
                            <div className={`${moduleCss.rightBtn} ${moduleCss.next2}`}>
                                <img
                                    src={isHoverRight ? rightNavHoverImage : rightNavImage}
                                    alt=""
                                    onMouseEnter={() => setIsHoverRight(true)}
                                    onMouseLeave={() => setIsHoverRight(false)}
                                />
                            </div>
                            <Mask visible={!swiperChip.id} zIndex={3}>
                                示例推荐位碎片—{swiperChip.default?.id}
                            </Mask>
                        </div>
                    </div>
                </Chip>
            </div>
        </div>
    );
};

export default Swiper_cjck;
